// eslint-disable-next-line @typescript-eslint/no-explicit-any
import React from 'react';
import { useQuery } from 'react-fetching-library';
import qs from 'qs';

import { useStyles } from './studentLoginInstitutionPage.styles';
import { Footer } from 'shared/templates/main/footer/Footer';
import { StudentLoginInstitutionHeader } from './studentLoginHeader/studentLoginInstitutionHeader';
import { Loader, Typography } from 'shared/components';
import { useLocale } from 'shared/hooks/useLocale/useLocale';
import { getInstitutionDataByInstitutionId } from 'api/actions/login/login.actions';
import { Image } from 'shared/components/image/Image';
import { InstitutionEventDataResponse } from 'api/actions/selfRegistration/selfRegistration.types';
import { StudentLoginInstitutionFormContainer } from './studentLoginInstitutionForm/studentLoginInstitutionFormContainer';

export const StudentLoginInstitutionPage = () => {
  const styles = useStyles();
  const { formatMessage } = useLocale();
  const params: any = qs.parse(window.location.href.split('?')[1]);
  const { loading, payload } = useQuery<InstitutionEventDataResponse>(getInstitutionDataByInstitutionId(params.id));

  return (
    <div>
      {loading ? (
        <Loader fullScreen withBackground />
      ) : (
        <div>
          <StudentLoginInstitutionHeader />
          <div className={styles.container}>
            <div>
              {payload?.institutionLogo && (
                <div className={styles.imgContainer}>
                  <Image className={styles.logoImage} alt="" src={payload?.institutionLogo} />
                </div>
              )}
              <Typography className={styles.rootText}>
                {formatMessage({ id: 'av_user.student_Name_Listener.root_message' })}
              </Typography>
              <Typography className={styles.rootTextSub}>
                {formatMessage({ id: 'av_user.student_Name_Listener.root_message_sub' })}
              </Typography>
            </div>
            <div className={styles.card}>
              <Typography className={styles.header}>
                {formatMessage({ id: 'av_user.student_login.login_title' })}
              </Typography>
              {payload && <StudentLoginInstitutionFormContainer instituitionEventDetails={payload} />}
            </div>
            <div className={styles.footerContainer}>
              <Footer />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
